// extracted by mini-css-extract-plugin
module.exports = {"pageName":"DashboardForNonAdmin_pageName__1IeKt","main":"DashboardForNonAdmin_main__2X9R1","column":"DashboardForNonAdmin_column__vBaFD","row":"DashboardForNonAdmin_row__3vaUk"};